// extracted by mini-css-extract-plugin
export default {"section":"Section_section__hJype","header":"Section_header__y45X1","sectionTitle":"Section_sectionTitle__WsERI","sectionSubtitle":"Section_sectionSubtitle__rys7S"};